import {Directive, ElementRef, ViewContainerRef} from "@angular/core";

@Directive({
  selector: '[intCellPosition]'
})
export class CellPositionDirective {

  topOffset: number = 0;

  constructor(
    private readonly vcr: ViewContainerRef,
    private readonly element: ElementRef
  ) {
    this.topOffset = this.element.nativeElement.offsetTop;
  }
}
